import { doc, getDoc, updateDoc, increment, serverTimestamp } from "firebase/firestore/lite";
import { db, DEFAULT_QR_BASE_URL } from "@/lib/firebase";
import { DEFAULT_LANGUAGES, sortLanguages } from "@/lib/i18n";

export async function getProduct(id) {
  if (!id || id.includes("/")) return null;
  const snap = await getDoc(doc(db, "products", id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function getSettings() {
  const snap = await getDoc(doc(db, "settings", "general"));
  const data = snap.exists() ? snap.data() : {};
  return {
    logoUrl: "", logoPath: "", ...data,
    qrBaseUrl: data.qrBaseUrl || DEFAULT_QR_BASE_URL,
    languages: sortLanguages(data.languages || DEFAULT_LANGUAGES),
    headings: data.headings || {},
  };
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDate(value) {
  if (!value) return "";
  const d = value.toDate ? value.toDate() : value instanceof Date ? value : new Date(value);
  if (isNaN(d)) return "";
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export const ADMIN_FLAG_KEY = "nqr:admin";

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export async function recordScan(id) {
  try {
    if (localStorage.getItem(ADMIN_FLAG_KEY)) return false;
    const key = `scan:${id}:${today()}`;
    if (localStorage.getItem(key)) return false;
    localStorage.setItem(key, "1");
    await updateDoc(doc(db, "products", id), { scanCount: increment(1), lastScannedAt: serverTimestamp() });
    return true;
  } catch (e) {
    console.warn("scan not recorded", e);
    return false;
  }
}
